import * as visit from 'unist-util-visit';
import { handleKeywordsOfNode } from './utils';
export var LIST_PLUGIN_ID = 'mfList';
export var List = function () {
  return function (tree) {
    var visitor = function (node) {
      var listItems = node.children;
      node.type = LIST_PLUGIN_ID;
      node.mark = undefined;
      if (listItems.length > 0) {
        var firstListItem = listItems[0];
        handleKeywordsOfNode(tree, firstListItem, function (keyword) {
          switch (keyword) {
            case 'tickmark':
              node.mark = 'tickmark';
              break;
            case 'crossmark':
              node.mark = 'crossmark';
              break;
          }
        });
      }
    };
    visit(tree, 'list', visitor);
  };
};